/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-const */
import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  makeStyles,
  Paper,
  Collapse,
  Chip,
} from '@material-ui/core';
import {
  eventDataSelector,
  commonSelector,
  userInfoSelector,
  copyStatusSelector,
  basicInfoSelector,
} from 'redux/custom-selector';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import SkeletonLoader from 'custom-components/skeletonLoader';
import producer from 'immer';
import isEmpty from 'lodash/isEmpty';
import { navLinks } from './navLink';
import { PricingPlan } from 'constants/pricingPlan';
import { API, POSTAPIWITHCUSTOMDOMAIN } from 'api-setup/api-helper';
import { useSource } from 'lib/custom-common-hooks';
import { GET_EVENT_COPY_STATUS, UPDATE_BEACON_STATUS } from 'api-setup/api-endpoints';
import projectSetting from 'settings';
import { setBeaconStatus } from 'redux/actions/copy-status-action';
import { getCopyModuleKey, getCopyModuleName } from 'lib/common-function';
import { COPY_EVENT_STATUS } from 'constants/common';
import { EventTypes } from './events/constants';
import { webinarNavLinks } from './webinarNavLinks';
import { EEventFormat } from './CreateNewEvent/common/constants';
import { filterOutLeadScoreFeature } from './engagement/lead-score/handlers';
import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react';

const useStyles = makeStyles((theme) => ({
  sidebarBlock: {
    transition: theme.transitions.create(['width', 'min-width', 'padding'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // borderRight: `1px solid ${theme.palette.border.light}`,
    overflowX: 'hidden',
    overflowY: 'scroll',
    width: 263,
    minWidth: 263,
    '@media (max-width: 1439px)': {
      width: 190,
      minWidth: 190,
    },
    borderRadius: 0,
    position: 'relative',
    height: '100%',
    flexShrink: 0,
    padding: '2rem 0 1rem 0',
    '&.collapsed': {
      width: 0,
      minWidth: 0,
      // padding: 0,
      padding: '2rem 0 1rem 0',
      borderRight: 'none',
    },
    '& .large-logo': {
      display: 'none',
      marginLeft: '1rem',
    },
    "&:hover": {
      "& .infoChipUI": {
        display: "none"
      },
      '& .small-logo': {
        display: 'none',
      },
      '& .large-logo': {
        display: 'block',
      }
    },
    '&:not(.loading):hover': {
      '& .activeCircle': {
        '&::before': {
          content: `""`,
          right: '10px',
        },
      },
    },
    scrollbarWidth: 'auto !important',
    scrollbarColor: '#F3F1F0 transparent !important',
    '-ms-overflow-style': '-ms-autohiding-scrollbar',
    '-webkit-overflow-scrolling': 'touch !important',
    '&::-webkit-scrollbar': {
      width: '8px !important',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent !important',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#F3F1F0 !important',
      borderRadius: '10px !important',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#F3F1F0 !important',
    },
    '&.MuiPaper-elevation1': {
      borderRadius: 0,
    },
  },
  linkDisabled: {
    '& div svg, & div span': {
      color: '#C0C0C0',
    },
  },
  actionTextStyle: {
    marginLeft: 0,
    textTransform: 'initial',
    '& .MuiTypography-root': {
      transition: theme.transitions.create(['color']),
      fontWeight: 500,
      fontFamily: theme.typography.fontFamily,
    },
  },
  actionIconStyle: {
    minWidth: 30,
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: theme.palette.text.primary,
    transition: theme.transitions.create(['color']),
  },
  actionBtnStyle: {
    padding: `${theme.spacing(0.75)}px ${theme.spacing(2)}px`,
    transition: theme.transitions.create(['background-color']),
    whiteSpace: 'nowrap',
    borderRadius: '0rem',
    '& .MuiListItemText-root': {
      color: theme.palette.text.grayColor3,
    },
    '& .MuiListItemIcon-root svg': {
      color: theme.palette.text.grayColor3,
    },
    '&.activeCircle': {
      position: 'relative',
      '&::before': {
        content: `""`,
        backgroundColor: '#FFBF3F',
        width: '8px',
        height: '8px',
        borderRadius: 0,
        position: 'absolute',
        right: '0px',
      },
    },
    '&.loading': {
      cursor: 'not-allowed',
      gap: theme.spacing(1),
    },
    '&.loading:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
    },
    '&:not(.loading):hover': {
      backgroundColor: 'var(--vpro-sidebar-hover)',
      color: theme.palette.text.primary,
      // transition: theme.transitions.create(['color']),
      // borderRight: `5px solid ${theme.palette.primary.main}`,
      '& div': {
        color: theme.palette.text.primary,
      },
      '& .MuiListItemIcon-root svg': {
        color: theme.palette.text.primary,
      },
    },
    '&.Mui-selected': {
      backgroundColor: 'var(--vpro-sidebar-hover)',
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['color']),
      // borderRight: `5px solid ${theme.palette.primary.main}`,
      '& div': {
        color: theme.palette.text.primary,
      },
      '& .MuiListItemIcon-root svg': {
        color: theme.palette.text.primary,
      },
    },
    '& .MuiChip-root': {
      "&.infoChipUI": {
        marginTop: 8,
        marginLeft: 0,
      },
      borderRadius: 0,
      padding: '0px',
      backgroundColor: '#FFBF3F',
      marginLeft: 10,
      textTransform: 'capitalize',
      height: 22,
      color: `${theme.palette.secondary.main} !important`,
      width: 'auto',
      minWidth: 'auto',
      fontSize: theme.fontSize.size9,
    },
  },
  subMenuActionBtnStyle: {
    padding: `${theme.spacing(0.75)}px ${theme.spacing(2)}px`,

    '& .MuiChip-root': {
      "&.infoChipUI": {
        marginTop: 8,
        marginLeft: 0,
      },
      borderRadius: 0,
      padding: '0px',
      backgroundColor: '#FFBF3F',
      marginLeft: 10,
      textTransform: 'capitalize',
      height: 22,
      color: `${theme.palette.secondary.main} !important`,
      width: 'auto',
      minWidth: 'auto',
      fontSize: theme.fontSize.size9,
    },
  },
  subMenuActionTextStyle: {
    marginLeft: 6,
  },
  divider: {
    borderBottom: `1px solid ${theme.palette.bg.whiteOff2}`,
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  logoHover: {
    '&:hover': {
      '& svg': {
        color: theme.palette.primary.light,
      },
      '& .logo-text': {
        color: theme.palette.primary.light,
      },
    },
  },
  sidebarList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '@media (max-width: 1439px)': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  collapseStyle: {
    paddingTop: '0.5rem',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem 0 0 2.5rem',
    marginBottom: '2.8rem',
    // height: 60,
    '& .event-logo': {
      cursor: 'pointer',
      '& svg': {
        width: 140,
      },
    },
  },
  userAvatar: {
    width: 36,
    height: 36,
    marginRight: theme.spacing(1.5),
    cursor: 'pointer',
    borderRadius: 0,
    '& .MuiAvatar-img': {
      height: 'auto',
    },
  },
  menuIcon: {
    margin: '0 1rem',
    '& svg': {
      color: theme.palette.grey[500],
    }
  },
}));


const getUpdNavLinks = (currentNavLinks, communityVersion = 1) => {
  const updLinks = currentNavLinks.map((eachLink) => {
    const updEachLink = { ...eachLink };
    if (!isEmpty(updEachLink?.subMenu)) {
      const updSubMenu = updEachLink?.subMenu.filter((eachSubLink) => {
        return eachSubLink?.communityVersion
          ? eachSubLink?.communityVersion === communityVersion
          : eachSubLink;
      });
      updEachLink.subMenu = updSubMenu;
    }
    if (updEachLink?.communityVersion && updEachLink?.communityVersion === communityVersion) {
      return updEachLink;
    }
    return updEachLink;
  });
  return updLinks;
};
/**
 * 
 * @param {Object} currentNavLinks (navMenu)
 * @param {[
 *  {
 *    menuId: <number>, // (required)
 *    subMenuName: <string>, // (optional) don't pass in case you want to hide the entire menu
 *    isHidden: boolean // (required) based this boolean value the menu will be shown/hidden
 *  }
 * ]} menuObj 
 * @returns updated navMenu
 */
const filterOutMenuItems = (currentNavLinks, menuObj) => {
  let updatedNavMenu = currentNavLinks;
  menuObj.forEach((menu) => {
    const { menuId, subMenuName, isHidden } = menu;
    if (!isHidden) return;
    updatedNavMenu = subMenuName ? updatedNavMenu.map((eachLink) => {
      if (menuId && eachLink.id === menuId) {
        return {
          ...eachLink,
          subMenu: eachLink.subMenu ? eachLink.subMenu.filter((subMenuItem) => {
            if (subMenuName && subMenuItem.name === subMenuName) {
              return false;
            }
            return true;
          }) : eachLink.subMenu
        }
      }
      return eachLink;
    }) : updatedNavMenu.filter((eachLink) => {
      if (menuId && eachLink.id === menuId) {
        return false
      }
      return true;
    });
  })
  return updatedNavMenu;
};
const CUSTOM_URL = projectSetting.customBaseURL2;

const getCurrentRouteSegment = (pathname) => {
  const pathParts = pathname.split('/').filter(Boolean);
  // Return the part after organiserId (index 3 and beyond)
  return '/' + pathParts.slice(3).join('/');
};

const isAnySubMenuSelected = (navLink, pathname) => {
  if (!navLink.subMenu || navLink.subMenu.length === 0) {
    return false;
  }

  const currentRoute = getCurrentRouteSegment(pathname);

  return navLink.subMenu.some(subMenuItem => {
    return currentRoute.startsWith(subMenuItem.url);
  });
};

const isMenuSelected = (navLink, pathname) => {
  const pathParts = pathname.split('/').filter(Boolean);

  if (navLink.id === 0) {
    return pathParts.length <= 3;
  }

  const currentRoute = getCurrentRouteSegment(pathname);

  if (navLink.subMenu && navLink.subMenu.length > 0) {
    if (isAnySubMenuSelected(navLink, pathname)) {
      return true;
    }
  }

  if (currentRoute === navLink.url) {
    return true;
  }

  if (!navLink.subMenu || navLink.subMenu.length === 0) {
    if (currentRoute.startsWith(navLink.url + '/')) {
      return true;
    }
  }

  if (navLink.subUrl && currentRoute.startsWith(navLink.subUrl)) {
    return true;
  }

  return false;
};

const isSubMenuSelected = (subMenuItem, pathname) => {
  const currentRoute = getCurrentRouteSegment(pathname);
  return currentRoute.startsWith(subMenuItem.url);
};

export default function SidebarNav({ onCloseSideBar, isOpen }) {
  const classes = useStyles();

  const history = useHistory();

  const match = useRouteMatch();

  const dispatch = useDispatch();

  const source = useSource();

  const eventData = useSelector(eventDataSelector, shallowEqual);
  const reduxData = useSelector(commonSelector, shallowEqual);
  const userInfo = useSelector(userInfoSelector, shallowEqual);
  const copyStatus = useSelector(copyStatusSelector, shallowEqual);
  const isWebinar = eventData.EventData && eventData.EventData.type === EEventFormat.WEBINAR;
  const { EventData } = eventData;
  const [callBeaconStatusAPI, setCallBeaconStatusAPI] = useState(false);
  const [menu, toggleMenu] = React.useState([]);
  const [activeLink, setActiveLink] = React.useState({
    mainLink: -1,
    subLink: -1,
  });
  const [isLoadSidebar, setLoadSidebar] = React.useState(true);
  const menuActiveLink = history.location.pathname;
  const setMenuActive = menuActiveLink.split('/', 5);
  const basicEventData = useSelector(basicInfoSelector, shallowEqual);
  const isLeadScoreEnabled = Boolean(eventData.EventData.isLeadScoreCalculationEnabled);

  const toggleSubMenu = (navLink) => {
    const newMenu = producer(menu, (draftMenu) => {
      draftMenu.filter((nav) => {
        if (nav.name === navLink.name) {
          nav.isSubMenuOpen = !nav.isSubMenuOpen;
        }
        return false;
      });
      return draftMenu;
    });
    toggleMenu(newMenu);
  };

  React.useEffect(() => {
    // let oldMenu = JSON.parse(JSON.stringify(menu));
    let oldMenu = isWebinar ? webinarNavLinks : navLinks;

    if (Object.keys(eventData.EventData).length > 0) {
      if (isWebinar && !isLeadScoreEnabled) {
        oldMenu = filterOutLeadScoreFeature(webinarNavLinks);
      }
      if (eventData.EventData.hasOwnProperty('isLoungeON')) {
        if (eventData.EventData.isLoungeON === 0) {
          setLoadSidebar(false);
          oldMenu = oldMenu.filter((x) => x.name.toLowerCase() !== 'lounge');
          //	toggleMenu(oldMenu)
        } else {
          setLoadSidebar(false);
        }
      }
      toggleMenu(oldMenu);
      if (typeof eventData.EventData.is_ticketing_from_new_dashboard !== 'undefined') {
        if (eventData.EventData.is_ticketing_from_new_dashboard === 0) {
          oldMenu = oldMenu.filter((x) => x.name.toLowerCase() !== 'registration');
        }
      }
      if (typeof eventData.EventData.is_ticketing_from_new_dashboard !== 'undefined') {
        oldMenu = getUpdNavLinks(oldMenu, eventData?.EventData?.is_ticketing_from_new_dashboard);
      }
      // Hide menu and submenu based on the isHidden condition
      oldMenu = filterOutMenuItems(oldMenu, [
        {
          menuId: 9, // (required)
          subMenuName: 'Quiz', // (optional) remove this key to hide the entire menu
          isHidden: !eventData.quiz_enabled // based on this condition the menu or sub menu will be hidden
        }
      ]);
      toggleMenu(oldMenu);
    } else {
      toggleMenu(oldMenu);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData]);

  React.useEffect(() => {
    const hasBuilder = get(eventData?.EventData || {}, 'is_email_builder', 1);
    if (
      // userInfo.UserInfo.id &&
      // (userInfo.UserInfo.subscriptionStatus === undefined ||
      //   userInfo.UserInfo.isPlanExpired ||
      //   userInfo.UserInfo.subscriptionStatus === 'CANCELLED' ||
      //   (userInfo.UserInfo.planName !== PricingPlan.PRO &&
      //     userInfo.UserInfo.planName !== PricingPlan.ENTERPRISE))
      eventData &&
      Object.keys(eventData?.EventData).length !== 0 &&
      !hasBuilder
    ) {
      const newMenu = menu.map((item) => {
        if (item.name.toLowerCase() === 'emails') return false;
        return item;
      });
      toggleMenu(newMenu.filter(Boolean));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData]);

  useEffect(() => {
    if (
      !callBeaconStatusAPI &&
      eventData?.EventData?.duplication_status === COPY_EVENT_STATUS.SUCCESS
    ) {
      const [headers] = API.generateHeader(reduxData);
      POSTAPIWITHCUSTOMDOMAIN(
        false,
        GET_EVENT_COPY_STATUS,
        source.AS,
        headers,
        { data: { eventId: eventData?.eventId } },
        projectSetting.customBaseURL2
      )
        .then((resp) => {
          const { status, success } = resp?.data;
          if (status) {
            setCallBeaconStatusAPI(true);
            const { data } = success;
            if (data)
              dispatch(setBeaconStatus({ beacon: data?.beacon, beaconModules: data?.modules }));
            else dispatch(setBeaconStatus({ beacon: true, beaconModules: [] }));
          }
        })
        .catch(API.catchHandler);
    }
    if (!eventData?.EventData?.duplication_status) {
      dispatch(setBeaconStatus({ beacon: false, beaconModules: [] }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData]);

  const closeAllSubMenu = () => {
    const newMenu = producer(menu, (draftMenu) => {
      draftMenu.filter((nav) => {
        if (nav.isSubMenuOpen !== undefined) {
          nav.isSubMenuOpen = false;
        }
        return false;
      });
      return draftMenu;
    });
    toggleMenu(newMenu);
  };

  const handleRedirect = (navLink, mainLinkId, subLinkId = 0) => {
    if (isLoadSidebar) return false;
    if (navLink.url) {
      if (navLink.hasEventIdAndOrganiserId) {
        const eventId = match.params.eventId
          ? match.params.eventId
          : history.location.state.eventId
            ? history.location.state.eventId
            : '';
        const organiserId = match.params.organiserId
          ? match.params.organiserId
          : history.location.state.organiserId
            ? history.location.state.organiserId
            : '';
        if (isWebinar && navLink.name.toLowerCase() === 'session') {
          if (eventData && eventData?.EventData && eventData?.EventData?.sessionId) {
            history.push(
              `/event/${eventId}/${organiserId}/session/${eventData?.EventData?.sessionId}/basic-details`
            );
          } else {
            history.push(`/event/${eventId}/${organiserId}`);
          }
        } else history.push(`/event/${eventId}/${organiserId}${navLink.url}`);
        setActiveLink({ mainLink: mainLinkId, subLink: subLinkId });
      } else {
        history.push(navLink.url);
      }
    }
  };
  const isBeaconShow = (moduleName) => {
    let isVisible;
    const { beaconModules, beacon } = copyStatus;
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < beaconModules?.length; index++) {
      const element = beaconModules[index];
      if (getCopyModuleName(element.type) === moduleName) {
        isVisible = beacon && element.beacon;
      }
    }
    return isVisible;
  };
  const hideBeaconIcon = (moduleName) => {
    let name = getCopyModuleKey(moduleName);
    let bodyObj = {
      data: {
        eventId: eventData.eventId,
        moduleType: name,
      },
    };
    const { beaconModules } = copyStatus;
    const updatedModules = beaconModules?.filter((e) => e.type !== name);

    const [headers] = API.generateHeader(reduxData, {}, null);
    POSTAPIWITHCUSTOMDOMAIN(false, UPDATE_BEACON_STATUS, source.AS, headers, bodyObj, CUSTOM_URL)
      .then((resp) => {
        const { status, success } = resp?.data;
        if (status) {
          const { data } = success;
          if (data)
            dispatch(setBeaconStatus({ beacon: data?.beacon, beaconModules: data?.modules }));
          else dispatch(setBeaconStatus({ beacon: true, beaconModules: updatedModules }));
        }
      })
      .catch(API.catchHandler);
  };

  const inPersonClassNameResolver = (navLink, index2) => {
    if (index2 === undefined) {
      return navLink.inPersonDisabledView &&
        basicEventData?.eventType === EventTypes.IN_PERSON &&
        !(`${setMenuActive[4]}` === 'undefined'
          ? navLink.id === 0
          : navLink.url === `/${setMenuActive[4]}`
            ? navLink.url === `/${setMenuActive[4]}`
            : navLink.subUrl === `/${setMenuActive[4]}`)
        ? classes.linkDisabled
        : '';
    } else {
      return navLink.inPersonDisabledView &&
        basicEventData?.eventType === EventTypes.IN_PERSON &&
        !(activeLink.subLink === index2)
        ? classes.linkDisabled
        : '';
    }
  };

  const monoRepoRouteHandler = ({ path }) => {
    if (path) {
      const originalURL = new URL(window.location.href);
      const [, , , , , eventId, organiserId] = originalURL.href.split('/');
      const newURL = `/${organiserId}/event/${eventId}/${path}`;
      const newAbsoluteURL = new URL(newURL, originalURL.origin);
      newAbsoluteURL.hash = ''; // Remove the hash fragment
      window.open(newAbsoluteURL, '_self');
    }
  };

  return (
    <Paper
      elevation={0}
      className={`${classes.sidebarBlock} ${isLoadSidebar ? 'loading' : ''} ${!isOpen ? 'collapsed' : ''}`}
    >
      <List disablePadding className={classes.sidebarList}>
        {menu.map((navLink, index) => {
          // Content hub Admin Toggle check
          // Admin Toggle Check for Content hub
          // eslint-disable-next-line no-lone-blocks
          {
            /* if (navLink.isInMonoRepo && !reduxData.isContentHubEnabled) {
            return null;
          } */
          }
          return (
            <>
              {reduxData && reduxData?.userPermission ? (
                reduxData?.userPermission?.isSuperAdmin?.toString() === '1' ||
                  reduxData?.userPermission?.isEventAdmin?.toString() === '1' ? (
                  <li key={navLink.name} className={inPersonClassNameResolver(navLink)}>
                    <ListItem
                      onClick={() => {
                        if (navLink.isInMonoRepo) {
                          monoRepoRouteHandler({ path: navLink.url });
                          // sidebar is inline now, no need to close
                        } else {
                          if (navLink.subMenu) {
                            if (isBeaconShow(navLink.name)) hideBeaconIcon(navLink.name);
                            toggleSubMenu(navLink);
                          } else {
                            if (isBeaconShow(navLink.name)) hideBeaconIcon(navLink.name);
                            handleRedirect(navLink, navLink.id);
                          }
                        }
                      }}
                      // selected={activeLink.mainLink === index}
                      // selected={
                      //   `${setMenuActive[4]}` === 'undefined'
                      //     ? navLink.id === 0
                      //     : navLink.url === `/${setMenuActive[4]}`
                      //       ? navLink.url === `/${setMenuActive[4]}`
                      //       : navLink.subUrl === `/${setMenuActive[4]}`
                      //         ? navLink.subUrl === `/${setMenuActive[4]}`
                      //         : menuActiveLink.includes(navLink.url)
                      // }
                      selected={isMenuSelected(navLink, menuActiveLink)}
                      button
                      className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'} 
                      ${classes.actionBtnStyle} ${isBeaconShow(navLink.name) ? 'activeCircle' : ''}
                      `}>
                      <ListItemIcon
                        disabled
                        className={classes.actionIconStyle}
                        id={isWebinar && navLink.name.toLowerCase() === 'session' ? 'sessionsNavLink' : ''}>
                        {isLoadSidebar ? (
                          <SkeletonLoader variant="round" height="32px" width="32px" />
                        ) : (
                          <Box component="span" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            {navLink.icon}
                            {navLink.isNew && <Chip component="span" className="infoChipUI" label="New" color="primary" size="small" />}
                          </Box>
                        )}
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          isLoadSidebar ? (
                            <SkeletonLoader variant="text" width="120px" height="20px" />
                          ) : (
                            <>
                              {navLink.name}
                              {navLink.isNew && <Chip label="New" color="primary" size="small" />}
                            </>
                          )
                        }
                        primaryTypographyProps={{
                          component: 'span',
                          variant: 'caption',
                          color: 'inherit',
                        }}
                        className={classes.actionTextStyle}
                      />
                      {!navLink.subMenu || !navLink.subMenu.length ? (
                        false
                      ) : navLink.isSubMenuOpen ? (
                        <CaretUpIcon weight='bold' />
                      ) : (
                        <CaretDownIcon weight='bold' />
                      )}
                    </ListItem>
                    {navLink.keyDivider ? <Box className={classes.divider} /> : false}
                    {!navLink.subMenu || !navLink.subMenu.length ? (
                      false
                    ) : (
                      <Collapse in={navLink.isSubMenuOpen} timeout="auto" unmountOnExit className={classes.collapseStyle}>
                        <List component="ul" disablePadding className={classes.sidebarList}>
                          {navLink.subMenu.map((nav, index2) => {
                            if (
                              nav.name.toLowerCase() === 'utm code' &&
                              !eventData.EventData?.are_utm_params_enabled
                            )
                              return null;
                            return (
                              <>
                                {nav.name.toLowerCase() === 'sponsored ads' ? (
                                  <>
                                    {userInfo.UserInfo.planName === PricingPlan.BASIC ||
                                      userInfo.UserInfo.planName === PricingPlan.ADVANCED ||
                                      userInfo.UserInfo.planName === PricingPlan.PRO ||
                                      userInfo.UserInfo.planName === PricingPlan.ENTERPRISE ||
                                      reduxData.is_sponsored_ads_support === 1 ? (
                                      <li
                                        key={nav.name}
                                        className={inPersonClassNameResolver(nav, index2)}>
                                        <ListItem
                                          onClick={() => {
                                            handleRedirect(nav, index, index2);
                                          }}
                                          button
                                          className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'
                                            } ${classes.actionBtnStyle} ${classes.subMenuActionBtnStyle
                                            }`}
                                          // selected={activeLink.subLink === index2}
                                          selected={isSubMenuSelected(nav, menuActiveLink)}
                                        >
                                          <ListItemText
                                            primary={nav.name}
                                            primaryTypographyProps={{
                                              variant: 'caption',
                                              color: 'inherit',
                                            }}
                                            className={`${classes.actionTextStyle} ${classes.subMenuActionTextStyle}`}
                                          />
                                        </ListItem>
                                      </li>
                                    ) : (
                                      ''
                                    )}
                                  </>
                                ) : (
                                  <li
                                    key={nav.name}
                                    className={inPersonClassNameResolver(nav, index2)}>
                                    <ListItem
                                      onClick={() => {
                                        handleRedirect(nav, index, index2);
                                      }}
                                      button
                                      className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'} ${classes.actionBtnStyle
                                        } ${classes.subMenuActionBtnStyle}`}
                                      // selected={activeLink.subLink === index2}
                                      selected={isSubMenuSelected(nav, menuActiveLink)}
                                    >
                                      <ListItemText
                                        primary={
                                          <>
                                            {nav.name}
                                            {/* {(
                                              nav.name === 'LEAD SCORE' ||
                                              nav.name === 'UTM code') && (
                                              <Chip label="New" color="primary" size="small" />
                                            )} */}
                                          </>
                                        }
                                        primaryTypographyProps={{
                                          variant: 'caption',
                                          color: 'inherit',
                                        }}
                                        className={`${classes.actionTextStyle} ${classes.subMenuActionTextStyle}`}
                                      />
                                    </ListItem>
                                  </li>
                                )}
                              </>
                            );
                          })}
                        </List>
                      </Collapse>
                    )}
                  </li>
                ) : navLink.id.toString() === '0' ||
                  reduxData.userPermission.selectedEventSections.findIndex(
                    (x) => x === navLink.id
                  ) !== -1 ? (
                  <li key={navLink.name} className={inPersonClassNameResolver(navLink)}>
                    <ListItem

                      onClick={() => {
                        if (navLink.isInMonoRepo) {
                          monoRepoRouteHandler({ path: navLink.url });
                        } else {
                          if (navLink.subMenu) {
                            toggleSubMenu(navLink);
                          } else {
                            handleRedirect(navLink, navLink.id);
                          }
                        }
                      }}
                      // selected={activeLink.mainLink === index}
                      // selected={
                      //   `${setMenuActive[4]}` === 'undefined'
                      //     ? navLink.id === 0
                      //     : navLink.url === `/${setMenuActive[4]}`
                      //       ? navLink.url === `/${setMenuActive[4]}`
                      //       : navLink.subUrl === `/${setMenuActive[4]}`
                      // }
                      selected={isMenuSelected(navLink, menuActiveLink)}
                      button
                      className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'} ${classes.actionBtnStyle
                        }`}>
                      <ListItemIcon className={classes.actionIconStyle}>
                        {isLoadSidebar ? (
                          <SkeletonLoader variant="round" height="32px" width="32px" />
                        ) : (
                          <Box component="span" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            {navLink.icon}
                            {navLink.isNew && <Chip component="span" className="infoChipUI" label="New" color="primary" size="small" />}
                          </Box>
                        )
                        }


                      </ListItemIcon>
                      <ListItemText
                        primary={
                          isLoadSidebar ? (
                            <SkeletonLoader variant="text" width="120px" height="20px" />
                          ) : <>
                            {navLink.name}
                            {navLink.isNew && <Chip label="New" color="primary" size="small" />}
                          </>
                        }
                        primaryTypographyProps={{
                          component: 'span',
                          variant: 'caption',
                          color: 'inherit',
                        }}
                        className={classes.actionTextStyle}
                      />
                      {!navLink.subMenu || !navLink.subMenu.length ? (
                        false
                      ) : navLink.isSubMenuOpen ? (
                        <CaretUpIcon weight='bold' />
                      ) : (
                        <CaretDownIcon weight='bold' />
                      )}
                    </ListItem>
                    {navLink.keyDivider ? <Box className={classes.divider} /> : false}
                    {!navLink.subMenu || !navLink.subMenu.length ? (
                      false
                    ) : (
                      <Collapse in={navLink.isSubMenuOpen} timeout="auto" unmountOnExit className={classes.collapseStyle}>
                        <List component="ul" disablePadding className={classes.sidebarList}>
                          {navLink.subMenu.map((nav, index2) => {
                            return (
                              <>
                                {nav.name.toLowerCase() === 'sponsored ads' ? (
                                  <>
                                    {userInfo.UserInfo.planName === PricingPlan.BASIC ||
                                      userInfo.UserInfo.planName === PricingPlan.ADVANCED ||
                                      userInfo.UserInfo.planName === PricingPlan.PRO ||
                                      userInfo.UserInfo.planName === PricingPlan.ENTERPRISE ||
                                      reduxData.is_sponsored_ads_support === 1 ? (
                                      <li
                                        key={nav.name}
                                        className={inPersonClassNameResolver(nav, index2)}>
                                        <ListItem
                                          onClick={() => {
                                            handleRedirect(nav, index, index2);
                                          }}
                                          button
                                          className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'
                                            } ${classes.actionBtnStyle} ${classes.subMenuActionBtnStyle
                                            }`}
                                          // selected={activeLink.subLink === index2}
                                          selected={isSubMenuSelected(nav, menuActiveLink)}
                                        >
                                          <ListItemText
                                            primary={nav.name}
                                            primaryTypographyProps={{
                                              variant: 'caption',
                                              color: 'inherit',
                                            }}
                                            className={`${classes.actionTextStyle} ${classes.subMenuActionTextStyle}`}
                                          />
                                        </ListItem>
                                      </li>
                                    ) : (
                                      ''
                                    )}
                                  </>
                                ) : (
                                  <li
                                    key={nav.name}
                                    className={inPersonClassNameResolver(nav, index2)}>
                                    <ListItem
                                      onClick={() => {
                                        handleRedirect(nav, index, index2);
                                        onCloseSideBar()
                                      }}
                                      button
                                      className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'} ${classes.actionBtnStyle
                                        } ${classes.subMenuActionBtnStyle}`}
                                      // selected={activeLink.subLink === index2}
                                      selected={isSubMenuSelected(nav, menuActiveLink)}
                                    >
                                      <ListItemText
                                        primary={nav.name}
                                        primaryTypographyProps={{
                                          variant: 'caption',
                                          color: 'inherit',
                                        }}
                                        className={`${classes.actionTextStyle} ${classes.subMenuActionTextStyle}`}
                                      />
                                    </ListItem>
                                  </li>
                                )}
                              </>
                            );
                          })}
                        </List>
                      </Collapse>
                    )}
                  </li>
                ) : null
              ) : (
                <li key={navLink.name} className={inPersonClassNameResolver(navLink)}>
                  <ListItem
                    onClick={() => {
                      if (navLink.subMenu) {
                        toggleSubMenu(navLink);
                      } else {
                        handleRedirect(navLink, navLink.id);
                      }
                    }}
                    // selected={activeLink.mainLink === index}
                    // selected={
                    //   `${setMenuActive[4]}` === 'undefined'
                    //     ? navLink.id === 0
                    //     : navLink.url === `/${setMenuActive[4]}`
                    //       ? navLink.url === `/${setMenuActive[4]}`
                    //       : navLink.subUrl === `/${setMenuActive[4]}`
                    // }
                    selected={isMenuSelected(navLink, menuActiveLink)}

                    button
                    className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'} ${classes.actionBtnStyle
                      }`}>
                    <ListItemIcon className={classes.actionIconStyle}>
                      {isLoadSidebar ? (
                        <SkeletonLoader variant="round" height="32px" width="32px" />
                      ) : (
                        navLink.icon
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        isLoadSidebar ? (
                          <SkeletonLoader variant="text" width="120px" height="20px" />
                        ) : (
                          navLink.name
                        )
                      }
                      primaryTypographyProps={{
                        component: 'span',
                        variant: 'caption',
                        color: 'inherit',
                      }}
                      className={classes.actionTextStyle}
                    />
                    {!navLink.subMenu || !navLink.subMenu.length ? (
                      false
                    ) : navLink.isSubMenuOpen ? (
                      <CaretUpIcon weight='bold' />
                    ) : (
                      <CaretDownIcon weight='bold' />
                    )}
                  </ListItem>
                  {navLink.keyDivider ? <Box className={classes.divider} /> : false}
                  {!navLink.subMenu || !navLink.subMenu.length ? (
                    false
                  ) : (
                    <Collapse in={navLink.isSubMenuOpen} timeout="auto" unmountOnExit className={classes.collapseStyle}>
                      <List component="ul" disablePadding className={classes.sidebarList}>
                        {navLink.subMenu.map((nav, index2) => {
                          return (
                            <>
                              {nav.name.toLowerCase() === 'sponsored ads' ? (
                                <>
                                  {userInfo.UserInfo.planName === PricingPlan.BASIC ||
                                    userInfo.UserInfo.planName === PricingPlan.ADVANCED ||
                                    userInfo.UserInfo.planName === PricingPlan.PRO ||
                                    userInfo.UserInfo.planName === PricingPlan.ENTERPRISE ||
                                    reduxData.is_sponsored_ads_support === 1 ? (
                                    <li
                                      key={nav.name}
                                      className={inPersonClassNameResolver(nav, index2)}>
                                      <ListItem
                                        onClick={() => {
                                          handleRedirect(nav, index, index2);
                                        }}
                                        button
                                        className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'
                                          } ${classes.actionBtnStyle} ${classes.subMenuActionBtnStyle
                                          }`}
                                        // selected={activeLink.subLink === index2}
                                        selected={isSubMenuSelected(nav, menuActiveLink)}
                                      >
                                        <ListItemText
                                          primary={nav.name}
                                          primaryTypographyProps={{
                                            variant: 'caption',
                                            color: 'inherit',
                                          }}
                                          className={`${classes.actionTextStyle} ${classes.subMenuActionTextStyle}`}
                                        />
                                      </ListItem>
                                    </li>
                                  ) : (
                                    ''
                                  )}
                                </>
                              ) : (
                                <li
                                  key={nav.name}
                                  className={inPersonClassNameResolver(nav, index2)}>
                                  <ListItem
                                    onClick={() => {
                                      handleRedirect(nav, index, index2);;

                                    }}
                                    button
                                    className={`${isLoadSidebar ? 'loading' : 'cursor-pointer'} ${classes.actionBtnStyle
                                      } ${classes.subMenuActionBtnStyle}`}
                                    // selected={activeLink.subLink === index2}
                                    selected={isSubMenuSelected(nav, menuActiveLink)}
                                  >
                                    <ListItemText
                                      primary={nav.name}
                                      primaryTypographyProps={{
                                        variant: 'caption',
                                        color: 'inherit',
                                      }}
                                      className={`${classes.actionTextStyle} ${classes.subMenuActionTextStyle}`}
                                    />
                                  </ListItem>
                                </li>
                              )}
                            </>
                          );
                        })}
                      </List>
                    </Collapse>
                  )}
                </li>
              )}
            </>
          );
        })}
      </List>
    </Paper>
  );
}
